import { API_BASE_URL } from "../../constants/index";
import HttpInterface from "../../helpers/HttpInterface";
import {
  defaultKpiShipmentPerformanceFilter,
  KpiShipmentPerformanceFilter,
} from "../../Models/KpiShipmentPerformance";
import {
  defaultKpiShipmentStatisticFilter,
  KpiShipmentStatisticFilter,
} from "../../Models/KpiShipmentStatistic";

export class KpiService {
  private httpProxy: HttpInterface;

  constructor() {
    this.httpProxy = new HttpInterface();
  }

  getStatistics(
    params: KpiShipmentStatisticFilter = defaultKpiShipmentStatisticFilter
  ): Promise<any> {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(params),
    };

    return this.httpProxy.fetch(
      `${API_BASE_URL}/shipment-service/kpi/statistics/shipments`,
      requestOptions
    );
  }

  getStatisticsAggregationDaily(
    params: KpiShipmentStatisticFilter = defaultKpiShipmentStatisticFilter
  ): Promise<any> {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(params),
    };

    return this.httpProxy.fetch(
      `${API_BASE_URL}/shipment-service/kpi/statistics/shipments/aggregation/daily`,
      requestOptions
    );
  }

  getPerformances(
    params: KpiShipmentPerformanceFilter = defaultKpiShipmentPerformanceFilter
  ): Promise<any> {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(params),
    };

    return this.httpProxy.fetch(
      `${API_BASE_URL}/shipment-service/kpi/performance/shipments`,
      requestOptions
    );
  }

  getPerformancesOnTime(
    params: KpiShipmentPerformanceFilter = defaultKpiShipmentPerformanceFilter
  ): Promise<any> {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(params),
    };

    return this.httpProxy.fetch(
      `${API_BASE_URL}/shipment-service/kpi/performance/shipments/on-time`,
      requestOptions
    );
  }

  getPerformancesFirstAttempt(
    params: KpiShipmentPerformanceFilter = defaultKpiShipmentPerformanceFilter
  ): Promise<any> {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(params),
    };

    return this.httpProxy.fetch(
      `${API_BASE_URL}/shipment-service/kpi/performance/shipments/first-attempt`,
      requestOptions
    );
  }

  getPerformancesFirstAttemptDelivered(
    params: KpiShipmentPerformanceFilter = defaultKpiShipmentPerformanceFilter
  ): Promise<any> {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(params),
    };

    return this.httpProxy.fetch(
      `${API_BASE_URL}/shipment-service/kpi/performance/shipments/first-attempt-delivered`,
      requestOptions
    );
  }

  getPerformancesDeliveryDaysGrouped(
    params: KpiShipmentPerformanceFilter = defaultKpiShipmentPerformanceFilter
  ): Promise<any> {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(params),
    };

    return this.httpProxy.fetch(
      `${API_BASE_URL}/shipment-service/kpi/performance/shipments/delivery-days-grouped`,
      requestOptions
    );
  }

  getPerformancesDelayedDaysGrouped(
    params: KpiShipmentPerformanceFilter = defaultKpiShipmentPerformanceFilter
  ): Promise<any> {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(params),
    };

    return this.httpProxy.fetch(
      `${API_BASE_URL}/shipment-service/kpi/performance/shipments/delayed-days-grouped`,
      requestOptions
    );
  }
}
